import { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import BalanceScreen from './balance'
import DepositScreen from './deposit'
import GiftCard from './gift'
import Homepage from './home'
import LeaderboardScreen from './leaderboard'
import ManageAccounts from './manage_accounts'
import MerchantApp from './merchant_home'
import Notifications from './notificaitons'
import SearchBar from './search'
import SelectContact from './select_contact'
import SendMoney from './send'
import ChatScreen from './send/chat'
import SendAnyone from './send_anyone.modal'
import SendToCPIID from './send_by_cpi_id'
import SendToAddress from './send_by_ens.modal'
import Setting from './settings'
import SetupPasskey from './setup-passkey'
import SetupUsername from './setup-username'
import Transactions from './transactions'
import UpdateAccountInfo from './update_account_info'
const animationMap: { [key: string]: string } = {
  '/dashboard/settings': 'fadeIn',
  '/dashboard/search': 'fadeIn',
  '/dashboard/send-money': 'slideUp',
}
const oldPages = new Set()
let lastAnimation = ''
const getAnimationClass = (location: { pathname: string; key: string }) => {
  let animation
  const isBack = location.pathname === '/dashboard' || oldPages.has(location.key)
  if (lastAnimation === 'fadeIn' && isBack) {
    animation = 'fadeIn'
  } else if (isBack) {
    animation = 'slideInLeft'
  } else {
    animation = animationMap[location.pathname] || 'slideInRight'
  }
  lastAnimation = animation
  return animation
}
const Dashbaord = () => {
  let location = useLocation()

  useEffect(() => {
    oldPages.add(location.key) //track opend paths
  }, [location.key])

  return (
    <TransitionGroup component={null}>
      <CSSTransition key={location.key} classNames={getAnimationClass(location)} timeout={300}>
        <Routes location={location}>
          {import.meta.env.VITE_BUSINESS_HOST === window.location.host ? <Route path="/*" element={<MerchantApp />} /> : <Route index element={<Homepage />} />}
          <Route path="/update-account/:accountId" element={<UpdateAccountInfo />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/setup-passkey" element={<SetupPasskey />} />
          <Route path="/setup-username" element={<SetupUsername />} />
          <Route path="/manage-accounts" element={<ManageAccounts />} />
          <Route path="/settings" element={<Setting />} />
          <Route path="/send-to-cpi" element={<SendToCPIID />} />
          <Route path="/send-to-address" element={<SendToAddress />} />
          <Route path="/send-anyone" element={<SendAnyone />} />
          <Route path="/gift-card/*" element={<GiftCard />} />
          <Route path="/select-contact" element={<SelectContact />} />
          <Route path="/topup" element={<DepositScreen />} />
          <Route path="/search" element={<SearchBar />} />
          <Route path="/send-money/*" element={<SendMoney />} />
          <Route path="/balance" element={<BalanceScreen />} />
          <Route path="/chat/:address" element={<ChatScreen />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/leaderboard" element={<LeaderboardScreen />} />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  )
}
export default Dashbaord
